import React from 'react';
import WaterTowersAddEdit from './water-towers-add-edit';
import WaterTowersAddEditModal from './water-towers-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { WATER_TOWERS_ADD_EDIT } = MODAL_TYPES;

const WaterTowersModals = () => {
  return (
    <>
      <WaterTowersAddEdit modalId={WATER_TOWERS_ADD_EDIT} />
      <WaterTowersAddEditModal />
    </>
  );
};

export default WaterTowersModals;
